<template>
    <div>
        <tsoft-table
            :key="componentRefreshKey"
            :api="tableApiUrl"
            :items.sync="items"
            :isNeedSearch="true"
            :additionalGetParameter="additionalGetParameter"
            :typeOfTableFilter="typeOfTableFilter"
            :onDataEmptyMessage="'Сотрудники отсутствуют. Добавьте сотрудников прямо сейчас.'"
            :headerContextMenuName="'companyEmployeeTable'"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
        />

        <b-sidebar
            v-if="isSidebarOpen"
            v-model="isSidebarOpen"
            id="sidebar-right"
            right
            backdrop
            shadow
            width="109em"
            backdrop-variant="dark"
            ref="editItem"
            no-close-on-backdrop
            @change="closeSidePanelCallback()"
        >
            <template #title>
                <div>
                    <strong id="sidebar-right___title__" v-html="modalTitle()"></strong>
                </div>
            </template>
            <div class="d-block">
                <form class="needs-validation mb-4" novalidate id="employeeForm">
                    <div class="row">
                        <div class="col-sm-12">
                            <h5 class="mb-3">Данные по сотруднику</h5>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-8">
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label>ФИО</label>
                                    <b-form-input
                                        required
                                        id="lead_fio"
                                        type="text"
                                        v-model="editedItem.lead_fio"
                                    ></b-form-input>
                                </div>
                                <div class="form-group col-md-6">
                                    <label>Должность</label>
                                    <b-form-input
                                        id="lead_position"
                                        type="text"
                                        v-model="editedItem.lead_position"
                                    ></b-form-input>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label>Мобильный телефон</label>
                                    <b-form-input
                                        required
                                        v-mask="'+#(###)###-##-##'"
                                        id="lead_phone"
                                        class="form-control"
                                        type="text"
                                        v-model="maskPhone"
                                        placeholder="+7(915)067-04-68"
                                    ></b-form-input>
                                </div>
                                
                                <div class="form-group col-md-6">
                                    <label>Офисный телефон</label>
                                    <b-form-input
                                        id="lead_company_phone"
                                        class="form-control"
                                        type="text"
                                        v-model.trim="editedItem.lead_company_phone"
                                        placeholder="+7(495)067-04-68 #0324"
                                    ></b-form-input>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label for="lead_email">E-mail</label>
                                    <b-form-input
                                        v-model.trim="editedItem.lead_email"
                                        type="text"
                                        class="form-control"
                                        id="lead_email"
                                    ></b-form-input>
                                </div>
        
                                <div class="form-group col-md-6">
                                    <label for="lead_date_of_birth">Дата рождения</label>
                                    <input 
                                        v-model="editedItem.lead_date_of_birth" 
                                        type="date"
                                        class="form-control" 
                                        id="lead_date_of_birth"
                                    >
                                </div>
                            </div>
        
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label>Дополнительные контактные данные</label>
                                    <b-form-input
                                        id="add_lead_phones"
                                        type="text"
                                        v-model="editedItem.add_lead_phones"
                                    ></b-form-input>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label>Ответственный за сегменты</label>
                                    <tsoft-select-of-properties
                                        key="set_segments_ids"
                                        :reference_id="86"
                                        :needNullElement="false"
                                        :needMultipleSelect="true"
                                        :defaultSelectName="``"
                                        :selectedArray="editedItem.set_segments_ids"
                                        :excludeArray="excludeServicesFromSegments"
                                        @set="setSegmentsOfEmployee"
                                    ></tsoft-select-of-properties>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-8">
                            <label>Опишите клиента, при необходимости (увидят только сотрудники Танаис)</label>
                            <b-form-textarea
                                id="textarea"
                                v-model="editedItem.lead_characteristic"
                                placeholder="Напишите несколько слов..."
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>
                        </div>
                    </div>
                </form>
            </div>
            <template #footer>
                <div class="row align-items-center">
                    <div class="col d-flex flex-row-reverse">
                        <button class="btn btn-primary text-right" type="submit" @click="submitForm($event)">Сохранить<i class="fas fa-spinner fa-spin ml-1" v-if="savingProcess"></i></button>
                    </div>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
    import {API_EMPLOYEES} from "../../constants"

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
    } from '../../mixins'

    const initialEditedItem = () => ({
        id: '',
        lead_fio: '',
        lead_position: '',
        lead_email: '',
        lead_phone: '',
        lead_company_phone: '',
        add_lead_phones: '',
        company_id: '',
        company: {},
        user_id: '',
        user: {},
        lead_characteristic: '',
        lead_date_of_birth: '',
        creator_user_id: '',
        creator: {},
        set_segments_ids: [],
        segments: []
    })

    export default {
        components: {
        },
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
        ],
        props: {
            companyId: { type: Number|String, required: false },
            isNeedCreate: { type: Boolean, required: false, default: true },        // If table needs create new element button
            additionalGetParameter: { type: String, required: false, default: '' }, // If we want to add something, for example, &order_id=10
            typeOfTableFilter: { type: String, required: false, default: '' },      // Type of filter for output: orders, services
            services: { type: Array, required: false }
        },
        data() {
            return {
                changeLoad: false,
                tableApiUrl: API_EMPLOYEES,
                componentRefreshKey: 0,
                maskPhone: '',
            }
        },
        watch: {
            maskPhone: function (phone){
                if (phone) {
                    let freshPhone = phone.replace(/[^0-9]/g, '')
                    this.editedItem.lead_phone = freshPhone
                }
            }
        },
        computed: {
            excludeServicesFromSegments() {
                let serviceReferences = this.$store.getters.GROUPED_REFERENCE_PROPERTIES[86];
                let excludeList = [];

                let serviceOnlyIds = this.services.map((service) => {
                    return service.id;
                });

                for(let key in serviceReferences) {
                    if (!serviceOnlyIds.includes(serviceReferences[key].id)) {
                        excludeList.push(serviceReferences[key].id);
                    }                    
                }

                return excludeList;
            }
        },
        mounted() {
            this.editedItem = initialEditedItem()
            this.initialAssign()
        },
        methods: {
            initialAssign() {
                if (this.companyId) {
                    this.editedItem.company_id = this.companyId
                }
            },
            // calls from mixin before sidebaropened
            beforeSidebarOpenedCallback() {
                this.editedItem = initialEditedItem()
                this.maskPhone = ''
                this.initialAssign()
            },
            // calls from mixin on item save
            onCreatedOrUpdatedCallback() {
                this.isSidebarOpen = false
            },
            // calls from mixin on item edit
            onItemEditModalCallback() {
                this.maskPhone = this.editedItem.lead_phone
            },
            setSegmentsOfEmployee(value) {
                this.editedItem.set_segments_ids = value
            },
            submitForm(event) {
                event.preventDefault()
                let form = document.getElementById("employeeForm")
                if (form.checkValidity() === false) {
                    event.preventDefault()
                    event.stopPropagation()
                    form.classList.add('was-validated')
                    return false
                }
                this.createOrUpdateItem()
            },
            onDeletedCallback() {
                this.componentRefreshKey++
                this.updateParentData()
            },
            modalTitle() {
                let title = 'Добавление сотрудника'
                if (this.editIndex > -1) {
                    title = 'Редактирование сотрудника #' + this.editedItem.id
                }

                return title
            },
            updateParentData() {
                this.$emit("updateParentData")
            }
        }
    }
</script>
